import { MobileOpCode } from 'graphql/generated/graphqlTypes';
import * as v1graphqlQueries from 'graphql/queries';
import * as graphqlQueries from 'graphql/v2/queries';
import { mockedGetAccessCardsDataForQuery } from 'mocks/graphqlApollo/query/getAccessCards';
import {
  mockedGetAccessEventsForTenantDataForQueryFirstFetch,
  mockedGetAccessEventsForTenantDataForQuerySecondFetch,
  mockedGetAccessEventsForTenantDataForQueryWithFiltersFirstFetch
} from 'mocks/graphqlApollo/query/getAccessEventsForTenant';
import { mockedGetAdminVisitorGroupsForTenantDataForQuery } from 'mocks/graphqlApollo/query/getAdminVisitorGroupsForTenant';
import { mockedGetAllVisitorsForTenantData } from 'mocks/graphqlApollo/query/getAllVisitorsForTenant';
import { mockedGetCardsDataForQuery } from 'mocks/graphqlApollo/query/getCards';
import { mockedGetCurrentTenantDataForQuery } from 'mocks/graphqlApollo/query/getCurrentTenant';
import {
  cleanGetAccessCardsData,
  cleanGetAllVisitorsForTenantData,
  cleanGetDoorsForTenantData,
  cleanGetLocationsForTenantData,
  cleanGetVisitorGroupsForTenantData,
  emptyGetAccessCardsData,
  emptyGetAllVisitorsForTenantData,
  emptyGetDoorsForTenantData,
  emptyGetLocationsForTenantData,
  emptyGetVisitorGroupsForTenantData
} from 'mocks/graphqlApollo/query/getDashboardCleanState';
import { mockedGetQrCodeVisitsForTenantData } from 'mocks/graphqlApollo/query/getQrCodeVisitsForTenant';
import { mockedGetRestAPIKeysDataForQuery } from 'mocks/graphqlApollo/query/getRestAPIKeys';
import { pickDashboardDemoData } from 'mocks/graphqlMocks/dashboardDemoState';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';
import { mockedGetAllVisitorsCardsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getAllVisitorsCardsWithoutNestedResolvers';
import { mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getAllVisitorsGroupsWithoutNestedResolvers';
import { mockedGetAllVisitorsVisitorGroupsDataForQuery } from '../graphqlApollo/query/getAllVisitorsVisitorGroups';
import { mockedGetAllVisitorsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getAllVisitorsWithoutNestedResolvers';
import { mockedGetCurrentVisitorAdminDataForQuery } from '../graphqlApollo/query/getCurrentVisitor';
import { mockedGetDoorsForAccessEventsFiltersDataForQuery } from '../graphqlApollo/query/getDoorsForAccessEventsFilters';
import {
  mockedGetDoorsForTenantDataAdmin,
  mockedGetDoorsForTenantDataForQuery
} from '../graphqlApollo/query/getDoorsForTenant';
import { mockedGetDoorsForTenantWithLocationsDataAdmin } from '../graphqlApollo/query/getDoorsForTenantWithLocations';
import { mockedGetDoorsWithOfficeDaysForTenantDataAdmin } from '../graphqlApollo/query/getDoorsForTenantWithOfficeMode';
import { mockedGetDoorsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getDoorsWithoutNestedResolvers';
import { mockedGetLocationsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getLocationsWithoutNestedResolvers';
import {
  mockedGetDeviceGroupDetailDoorsDataAdmin,
  mockedGetLocationWithDoorsForTenantDataAdmin
} from '../graphqlApollo/query/getLocationWithDoorsForTenant';
import {
  mockedGetVisitorDetailsData,
  mockedGetVisitorDetailsDataForQueryVisitor1,
  mockedGetVisitorDetailsDataForQueryVisitor10,
  mockedGetVisitorDetailsDataForQueryVisitor11,
  mockedGetVisitorDetailsDataForQueryVisitor12,
  mockedGetVisitorDetailsDataForQueryVisitor13,
  mockedGetVisitorDetailsDataForQueryVisitor14,
  mockedGetVisitorDetailsDataForQueryVisitor15,
  mockedGetVisitorDetailsDataForQueryVisitor16,
  mockedGetVisitorDetailsDataForQueryVisitor17,
  mockedGetVisitorDetailsDataForQueryVisitor18,
  mockedGetVisitorDetailsDataForQueryVisitor19,
  mockedGetVisitorDetailsDataForQueryVisitor2,
  mockedGetVisitorDetailsDataForQueryVisitor20,
  mockedGetVisitorDetailsDataForQueryVisitor3,
  mockedGetVisitorDetailsDataForQueryVisitor4,
  mockedGetVisitorDetailsDataForQueryVisitor5,
  mockedGetVisitorDetailsDataForQueryVisitor6,
  mockedGetVisitorDetailsDataForQueryVisitor7,
  mockedGetVisitorDetailsDataForQueryVisitor8,
  mockedGetVisitorDetailsDataForQueryVisitor9,
  mockedGetVisitorDetailsDataForQueryVisitorInstaller2
} from '../graphqlApollo/query/getVisitorDetails';
import { mockedGetVisitorDetailsDoorsDataForQuery } from '../graphqlApollo/query/getVisitorDetailsDoors';
import { mockedGetVisitorDetailsLockGroupsDataForQuery } from '../graphqlApollo/query/getVisitorDetailsLockGroups';
import { mockedGetVisitorDetailsVisitorGroupsDataForQuery } from '../graphqlApollo/query/getVisitorDetailsVisitorGroups';
import { mockedGetVisitorGroupsForTenantWithAccessGrantsDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithAccessGrants';
import { mockedGetVisitorGroupsForTenantWithIsAdminGroupDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsAdminGroupDataForQuery';
import { mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithIsOfficeModeEnabled';
import { mockedGetVisitorGroupsForTenantWithMembersAndRoleDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndRole';
import {
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataAdmin,
  mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery
} from '../graphqlApollo/query/getVisitorGroupsForTenantWithMembersAndTypes';
import { mockedGetVisitorGroupsWithSchedulesForTenantDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithSchedules';
import { mockedGetVisitorGroupsForTenantWithTypesDataAdmin } from '../graphqlApollo/query/getVisitorGroupsForTenantWithTypes';
import { mockedGetVisitorGroupsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getVisitorGroupsWithoutNestedResolvers';
import { mockedGetVisitorsAccessEventsFiltersDataForQuery } from '../graphqlApollo/query/getVisitorsAccessEventsFilters';
import { mockedGetVisitorsGroupsDeviceDetailsDataForQuery } from '../graphqlApollo/query/getVisitorsGroupsDeviceDetails';
import { mockedGetVisitorsWithoutNestedResolversDataForQuery } from '../graphqlApollo/query/getVisitorsWithoutNestedResolvers';

const visitorDetailsQueries = [
  { id: 'mockVisitorId1', data: mockedGetVisitorDetailsDataForQueryVisitor1 },
  { id: 'mockVisitorId2', data: mockedGetVisitorDetailsDataForQueryVisitor2 },
  { id: 'mockVisitorId3', data: mockedGetVisitorDetailsDataForQueryVisitor3 },
  { id: 'mockVisitorId4', data: mockedGetVisitorDetailsDataForQueryVisitor4 },
  { id: 'mockVisitorId5', data: mockedGetVisitorDetailsDataForQueryVisitor5 },
  { id: 'mockVisitorId6', data: mockedGetVisitorDetailsDataForQueryVisitor6 },
  { id: 'mockVisitorId7', data: mockedGetVisitorDetailsDataForQueryVisitor7 },
  { id: 'mockVisitorId8', data: mockedGetVisitorDetailsDataForQueryVisitor8 },
  { id: 'mockVisitorId9', data: mockedGetVisitorDetailsDataForQueryVisitor9 },
  { id: 'mockVisitorId10', data: mockedGetVisitorDetailsDataForQueryVisitor10 },
  { id: 'mockVisitorId11', data: mockedGetVisitorDetailsDataForQueryVisitor11 },
  { id: 'mockVisitorId12', data: mockedGetVisitorDetailsDataForQueryVisitor12 },
  { id: 'mockVisitorId13', data: mockedGetVisitorDetailsDataForQueryVisitor13 },
  { id: 'mockVisitorId14', data: mockedGetVisitorDetailsDataForQueryVisitor14 },
  { id: 'mockVisitorId15', data: mockedGetVisitorDetailsDataForQueryVisitor15 },
  { id: 'mockVisitorId16', data: mockedGetVisitorDetailsDataForQueryVisitor16 },
  { id: 'mockVisitorId17', data: mockedGetVisitorDetailsDataForQueryVisitor17 },
  { id: 'mockVisitorId18', data: mockedGetVisitorDetailsDataForQueryVisitor18 },
  { id: 'mockVisitorId19', data: mockedGetVisitorDetailsDataForQueryVisitor19 },
  { id: 'mockVisitorId20', data: mockedGetVisitorDetailsDataForQueryVisitor20 },
  { id: 'mockVisitorInstaller2', data: mockedGetVisitorDetailsDataForQueryVisitorInstaller2 },
  {
    id: 'mockedAutomatedTestsUIAdminVisitorId',
    data: mockedGetVisitorDetailsData(mockedGetCurrentVisitorAdminDataForQuery.getCurrentVisitor)
  }
];

const visitorAccessEventsIds = visitorDetailsQueries.map(({ id }) => id);

const doorAccessEventsIds = mockDoors.map(({ id }) => id);

export const queries = [
  {
    request: {
      query: v1graphqlQueries.GET_CURRENT_HOST
    },
    newData: () => ({
      data: mockedGetCurrentVisitorAdminDataForQuery
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_CURRENT_VISITOR
    },
    newData: () => ({
      data: mockedGetCurrentVisitorAdminDataForQuery
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_CURRENT_TENANT
    },
    newData: () => ({
      data: mockedGetCurrentTenantDataForQuery
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_DOORS_FOR_TENANT_WITH_OFFICE_MODE
    },
    newData: () => ({
      data: mockedGetDoorsWithOfficeDaysForTenantDataAdmin
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS_AND_ROLE,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndRoleDataAdmin
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataAdmin
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_WITH_PERMISSIONS,
      variables: {
        filter: {
          type: VisitorGroupType.AzureAd
        }
      }
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithIsAdminGroupDataAdmin
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_SCHEDULES
    },
    newData: () => ({
      data: mockedGetVisitorGroupsWithSchedulesForTenantDataAdmin
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithTypesDataAdmin
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_IS_OFFICE_MODE_ENABLED
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithIsOfficeModeEnabledDataAdmin
    })
  },
  {
    request: {
      query: graphqlQueries.GET_LOCATIONS_WITH_DOORS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetLocationWithDoorsForTenantDataAdmin
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_DOORS_FOR_TENANT_WITH_LOCATIONS
    },
    newData: () => ({
      data: mockedGetDoorsForTenantWithLocationsDataAdmin
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_ACCESS_GRANTS
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithAccessGrantsDataAdmin
    })
  },
  {
    request: {
      query: graphqlQueries.GET_REST_API_KEYS
    },
    newData: () => ({
      data: mockedGetRestAPIKeysDataForQuery
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_CARDS
    },
    newData: () => ({
      data: mockedGetCardsDataForQuery
    })
  },
  {
    request: {
      query: v1graphqlQueries.GET_ALL_VISITORS_CARDS
    },
    newData: () => ({
      data: mockedGetCardsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_CARDS
    },
    newData: () => ({
      data: pickDashboardDemoData(emptyGetAccessCardsData, cleanGetAccessCardsData, mockedGetAccessCardsDataForQuery)
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: { filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] } }
    },
    newData: () => ({
      data: mockedGetAccessEventsForTenantDataForQueryFirstFetch
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        nextToken: 'mockedNextToken',
        filter: { actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    newData: () => ({
      data: mockedGetAccessEventsForTenantDataForQuerySecondFetch
    })
  },
  ...visitorAccessEventsIds.map((visitorId) => ({
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        filter: { visitorIds: [visitorId], actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    newData: () => ({
      data: mockedGetAccessEventsForTenantDataForQueryWithFiltersFirstFetch
    })
  })),
  ...doorAccessEventsIds.map((doorId) => ({
    request: {
      query: graphqlQueries.GET_ACCESS_EVENTS_FOR_TENANT,
      variables: {
        filter: { doorIds: [doorId], actions: [MobileOpCode.AccessDenied, MobileOpCode.AccessGranted] }
      }
    },
    newData: () => ({
      data: mockedGetAccessEventsForTenantDataForQueryWithFiltersFirstFetch
    })
  })),
  {
    request: {
      query: v1graphqlQueries.GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS
    },
    newData: () => ({
      data: mockedGetVisitorGroupsForTenantWithMembersAndTypesDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ADMIN_VISITOR_GROUPS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetAdminVisitorGroupsForTenantDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_GROUPS
    },
    newData: () => ({
      data: pickDashboardDemoData(
        emptyGetVisitorGroupsForTenantData,
        cleanGetVisitorGroupsForTenantData,
        mockedGetVisitorGroupsForTenantWithAccessGrantsDataAdmin
      )
    })
  },
  {
    request: {
      query: graphqlQueries.GET_DEVICE_GROUPS_WITH_DOORS
    },
    newData: () => ({
      data: pickDashboardDemoData(
        emptyGetLocationsForTenantData,
        cleanGetLocationsForTenantData,
        mockedGetLocationWithDoorsForTenantDataAdmin
      )
    })
  },
  {
    request: {
      query: graphqlQueries.GET_DEVICE_GROUP_DETAIL_DOORS
    },
    newData: () => ({
      data: mockedGetDeviceGroupDetailDoorsDataAdmin
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_DOORS_FOR_DEVICE_GROUPS
    },
    newData: () => ({
      data: mockedGetDoorsForTenantDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_FOR_TENANT
    },
    newData: () => ({
      data: pickDashboardDemoData(
        emptyGetAllVisitorsForTenantData,
        cleanGetAllVisitorsForTenantData,
        mockedGetAllVisitorsForTenantData
      )
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS
    },
    newData: () => ({
      data: mockedGetAllVisitorsVisitorGroupsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.CoContractors
        }
      }
    },
    newData: () => ({
      data: mockedGetAllVisitorsVisitorGroupsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Administrators
        }
      }
    },
    newData: () => ({
      data: mockedGetAllVisitorsVisitorGroupsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_VISITOR_GROUPS,
      variables: {
        filter: {
          type: VisitorGroupType.Installers
        }
      }
    },
    newData: () => ({
      data: mockedGetAllVisitorsVisitorGroupsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_DOORS_FOR_TENANT
    },
    newData: () => ({
      data: pickDashboardDemoData(
        emptyGetDoorsForTenantData,
        cleanGetDoorsForTenantData,
        mockedGetDoorsForTenantDataAdmin
      )
    })
  },
  ...visitorDetailsQueries.map(({ id, data }) => ({
    request: {
      query: graphqlQueries.GET_VISITOR_DETAILS,
      variables: { id }
    },
    newData: () => ({ data })
  })),
  {
    request: {
      query: graphqlQueries.GET_VISITOR_DETAILS_DOORS
    },
    newData: () => ({
      data: mockedGetVisitorDetailsDoorsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_DETAILS_LOCK_GROUPS
    },
    newData: () => ({
      data: mockedGetVisitorDetailsLockGroupsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_DETAILS_VISITOR_GROUPS
    },
    newData: () => ({
      data: mockedGetVisitorDetailsVisitorGroupsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_CARDS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetAllVisitorsCardsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_GROUPS_WITHOUT_NESTED_RESOLVERS,
      variables: { filter: undefined }
    },
    newData: () => ({
      data: mockedGetAllVisitorsGroupsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_ALL_VISITORS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetAllVisitorsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITORS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetVisitorsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITOR_GROUPS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetVisitorGroupsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_LOCATIONS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetLocationsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_DOORS_WITHOUT_NESTED_RESOLVERS
    },
    newData: () => ({
      data: mockedGetDoorsWithoutNestedResolversDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_DOORS_FOR_ACCESS_EVENTS_FILTERS
    },
    newData: () => ({
      data: mockedGetDoorsForAccessEventsFiltersDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITORS_ACCESS_EVENTS_FILTERS
    },
    newData: () => ({
      data: { getVisitors: mockedGetVisitorsAccessEventsFiltersDataForQuery.getVisitors }
    })
  },
  {
    request: {
      query: graphqlQueries.GET_VISITORS_GROUPS_DEVICE_DETAILS
    },
    newData: () => ({
      data: mockedGetVisitorsGroupsDeviceDetailsDataForQuery
    })
  },
  {
    request: {
      query: graphqlQueries.GET_QR_CODE_VISITS_FOR_TENANT
    },
    newData: () => ({
      data: mockedGetQrCodeVisitsForTenantData
    })
  }
];
